<template>
  <div class="blood-donor">
    <h1 class="hide-wcag">Krwiodawca pierwszorazowy</h1>
    <Hero :dataProps="data.hero" image="/svg/blood-donor/hero.svg" class="pattens-blue" />
    <BeforeDonation :dataProps="data.tiles" />
    <Steps :dataProps="data.steps" />
    <Food :dataProps="data.food" :food="food" />
    <Calendar :dataProps="data.calendar" />
    <Contraindications :dataProps="data.contraindications" />
    <Airplane :dataProps="data.airplane" />
    <Video :dataProps="data.video" />
    <FactsAndMyths :dataProps="data.facts_myths" />
    <Benefits :dataProps="data.benefits" />
  </div>
</template>

<script>
import Vue from 'vue';
import Hero from '@/components/partials/Hero';
import BeforeDonation from '@/components/blood-donor/BeforeDonation';
import Steps from '@/components/blood-donor/Steps';
import Food from '@/components/blood-donor/Food';
import Calendar from '@/components/blood-donor/Calendar';
import Contraindications from '@/components/blood-donor/Contraindications';
import Airplane from '@/components/blood-donor/Airplane';
import Video from '@/components/blood-donor/Video';
import FactsAndMyths from '@/components/blood-donor/FactsAndMyths';
import Benefits from '@/components/blood-donor/Benefits';
import { HTTP } from '@/utils/http-common';
import { dealWithHttpErrors } from '@/mixins/deal-with-http-errors';

export default Vue.extend({
  mixins: [
    dealWithHttpErrors,
  ],
  components: {
    Hero,
    BeforeDonation,
    Steps,
    Food,
    Calendar,
    Contraindications,
    Airplane,
    Video,
    FactsAndMyths,
    Benefits,
  },
  data() {
    return {
      data: {
        airplane: {
          content: '',
          href: '',
          button: '',
        },
      },
      food: {
        healthy: [
          {
            name: 'Różne rodzaje kaszy',
            icon: 'groats',
          },
          {
            name: 'Ryby',
            icon: 'fish',
          },
          {
            name: 'Chude mięso',
            icon: 'meat',
          },
          {
            name: 'Pieczywo pełnoziarniste',
            icon: 'bread',
          },
          {
            name: 'Owoce i warzywa',
            icon: 'fruit',
          },
          {
            name: 'Twaróg, chudy ser biały',
            icon: 'cheese',
          },
          {
            name: 'Miód, dżem, powidła',
            icon: 'jam',
          },
          {
            name: 'Mleko',
            icon: 'milk',
          },
          {
            name: 'Soki owocowe lub warzywne',
            icon: 'juice',
          },
          {
            name: 'Woda, herbata ',
            icon: 'tea',
          },
        ],
        noHealthy: [
          {
            name: 'Wszelkie dania o wysokiej zawartości tłuszczu',
            icon: 'doughnut',
          },
          {
            name: 'Dania smażone',
            icon: 'fast-food',
          },
          {
            name: 'Tłuste mięso',
            icon: 'fat-meat',
          },
          {
            name: 'Wysokokaloryczne desery – ciastka, kremy, lody',
            icon: 'cake',
          },
          {
            name: 'Śmietana, majonez, margaryna, smalec',
            icon: 'butter',
          },
          {
            name: 'Jaja',
            icon: 'egg',
          },
          {
            name: 'Napoje słodzone',
            icon: 'soda',
          },
        ],
      },
    };
  },
  created() {
    HTTP.get('acf/v3/pages/169').then((response) => {
      this.data = response.data.acf;
    }).catch((e) => {
      this.handleError(e.response);
    });
  },
});
</script>